import { globalCss } from 'themes';

export const globalStyles = globalCss({
  '#footer footer *': {
    fontFamily: 'var(--font-family-default)',
  },
});
